angular
	.module 'App.Module.Account', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'settings',
				url: '/settings',
				abstract: true,
				views:
					"main":
						templateUrl: '@app/account/account.view.html'
			.state 'settings.account',
					url: '^/settings/account?cardno',
					views:
						"main@":
							controller: 'AccountController'
							controllerAs: 'vm'
							bindToController: true
							templateUrl: '@app/account/account.view.html'
					data:
						pageTitle: 'Settings - Account'
						hideSubMenu: false
						restrict: "Backoffice.TopMenu.Setting.Account"
					resolvePolicy: DEFAULT_RESOLVE_POLICY
					resolve:
						Infrasec: (InfrasecRepository) ->
							return InfrasecRepository.status()
						CompaniesCount: (CompanyRepository) ->
							return CompanyRepository
								.count()
								.then (response) ->
									return parseInt(response.data.count)
								.catch ->
									return 0
						currentLicense: (AccountLicenseService) ->
							return AccountLicenseService
								.findCurrent()
								.then (response) -> return response.data
								.catch -> return {}
						licenseBundles: (AccountLicenseService) ->
							return AccountLicenseService
								.findBundles()
								.then (response) -> return response.data
								.catch -> return []
						registersCount: (RegisterRepository) ->
							return RegisterRepository.countEntities()
						priceRegions: (PriceRegionRepository) ->
							return PriceRegionRepository.getEntities()
						languages: (PublicRepository) ->
							return PublicRepository.getTranslatedLanguages()
